var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showZero || _vm.value)?_c('pre',_vm._b({},'pre',_vm.$attrs,false),[_vm._v(_vm._s(_vm.formatter().format(parseFloat(`${_vm.value}`)))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }